import React from "react";
import { useNavigate } from "react-router-dom";

const WelcomeS = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>


            <div className="vivify fadeInBottom duration-500" style={{
                marginTop: '15vh'
            }}>
                <div className="image-center">
                    <img src="/assets/steven.png" alt="dad" />
                </div>
                <h1 className="large-text">Welcome To Your Recap Steven!</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/steven/drive');
                        }
                    } className="large-button">
                        Let's Go!
                    </button>
                </div>
            </div>

        </div>
    );
}

export default WelcomeS;